import { VendorApiDto, VendorFormDto } from "./module";

const transform = (input: VendorApiDto) : VendorFormDto => {
    input.address2 = null === input.address2 ? '' : input.address2;
    input.phone = null === input.phone ? '' : input.phone;

    return input as VendorFormDto;
}

export { transform }